module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"line1":"Just a moment...","line2":"I\u0027m working on you request."},"es":{"line1":"Sólo un momento...","line2":"Estoy trabajando en tu solicitud."}}')
  delete Component.options._Ctor
}
